@if (pushs && show) {
  <sd-component-wrapper
    id="BenefitsCardPushComponent_{{pageTemplate.charAt(0).toUpperCase() + pageTemplate.slice(1).toLowerCase()}}Page_1"
    [content]="wrapper"
    [textConfig]="textConfig"
    [layoutTextConfig]="textConfig"
    [themesConfig]="lameConfig?.backgroundTheme"
  >
    <sd-push-slider sd-component-wrapper-component
      id="benefits-list"
      [pushs]="pushs"
      [hasReadMore]="hasReadMore"
      [size]="size"
      [brand]="brand"
      [titleLevel]="3"
      (clicked)="onClickLink($event)"
    />
  </sd-component-wrapper>
}
